__turbopack_context__.v({
  "ways-to-use": "WaysToUse-module-scss-module__edOKbW__ways-to-use",
  "ways-to-use__body": "WaysToUse-module-scss-module__edOKbW__ways-to-use__body",
  "ways-to-use__content": "WaysToUse-module-scss-module__edOKbW__ways-to-use__content",
  "ways-to-use__headline": "WaysToUse-module-scss-module__edOKbW__ways-to-use__headline",
  "ways-to-use__image": "WaysToUse-module-scss-module__edOKbW__ways-to-use__image",
  "ways-to-use__image-wrap": "WaysToUse-module-scss-module__edOKbW__ways-to-use__image-wrap",
  "ways-to-use__item": "WaysToUse-module-scss-module__edOKbW__ways-to-use__item",
  "ways-to-use__list": "WaysToUse-module-scss-module__edOKbW__ways-to-use__list",
  "ways-to-use__title": "WaysToUse-module-scss-module__edOKbW__ways-to-use__title",
});
